import { render, staticRenderFns } from "./detection-config-gender-selector.vue?vue&type=template&id=6b0a6bcc&"
import script from "./detection-config-gender-selector.vue?vue&type=script&lang=js&"
export * from "./detection-config-gender-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports